export default function getResource(label, vars = []) {
    const resources = {
        optinCreateHeading: 'Laissez tomber votre mot de passe lors de votre prochaine visite et connectez-vous de manière plus rapide et sécuritaire',
        subheading: 'Utilisez le même visage ou la même empreinte digitale que vous utilisez pour déverrouiller votre appareil. Nous ne recevons jamais vos données biométriques comme les empreintes digitales ou les balayages du visage.',
        warningNotification: 'Non recommandé pour les appareils partagés.',
        termsAndConditions: 'En cliquant sur « Continuer », vous (1) acceptez la version actuelle de nos ',
        termsOfUse: 'CONDITIONS D’UTILISATION',
        termsAndConditionsRest: ' et (2) confirmez avoir lu notre ',
        privacyPolicy: 'politique de confidentialité',
        whatIsPasskey: 'Qu’est-ce qu’une clé d’accès?',
        setupButton: 'Continuer',
        maybeLaterButton: 'Peut-être plus tard',
        laterButton: 'Plus tard',
        passkeyErrorTitle: 'Erreur',
        passkeyErrorMessage: 'La création de la clé d’accès a échoué. Veuillez essayer de nouveau.',
        passkeyErrorButton: 'OK',
        passkeyExpiredLinkMessage: 'Your link for creating a passkey has expired.<br><br>Please hit resend to get a new passkey email. If you are unable to create a passkey from the email try using another device or reset your password instead. If unable to reset password you can contact Customer service at 1-877-SEPHORA(1-877—377-4672) for assistance',
        passkeyUnsupportedDeviceMessage: 'Your device is not eligible for passkey creation.',
        createNewPasskey: 'Créer un nouveau mot de passe',
        cancel: 'Annuler',
        passkeyCreated: 'Clé d’accès créée!',
        optinCreateAccountHeading: 'Créer un nouveau mot de passe'
    };

    return resources[label];
}
